// 1:1 port of prototype/components/core/ProgressBar.jsx (design D3): same name,
// same prop contract (prototype/components/core/ProgressBar.d.ts), styled only
// from token CSS vars.

import type { CSSProperties } from 'react';

export interface ProgressBarSegment {
  from: number;
  to: number;
  color: string;
}

export interface ProgressBarProps {
  value?: number;
  max?: number;
  /** Fill color; default honey-500. */
  color?: string;
  track?: string;
  height?: number;
  /** Optional background segments (e.g. season split): {from, to, color} in 0-1. */
  segments?: ProgressBarSegment[];
  style?: CSSProperties;
}

export function ProgressBar({
  value = 0,
  max = 1,
  color = 'var(--honey-500)',
  track = 'var(--paper-2)',
  height = 8,
  segments,
  style,
}: ProgressBarProps) {
  const pct = Math.max(0, Math.min(1, value / max)) * 100;
  return (
    <div
      style={{
        borderRadius: height / 2,
        background: track,
        height,
        overflow: 'hidden',
        position: 'relative',
        ...style,
      }}
    >
      {segments
        ? segments.map((s, i) => (
            <div
              key={i}
              style={{
                position: 'absolute',
                left: `${s.from * 100}%`,
                width: `${(s.to - s.from) * 100}%`,
                top: 0,
                bottom: 0,
                background: s.color,
              }}
            />
          ))
        : null}
      <div
        style={{
          width: `${pct}%`,
          height: '100%',
          borderRadius: height / 2,
          background: color,
          transition: 'width var(--dur-med) var(--ease-out)',
          position: 'relative',
        }}
      />
    </div>
  );
}
